import { FC } from 'react';
import { container } from 'system/registry';
import { LoadingProvider } from 'application/contexts/useLoading';
import { diContainerContext } from 'application/contexts/useDiContainer';
import { supportUserContext, useSupportUser } from 'application/contexts/useSupportUser';
import { supporterChatContext, useSupporterChat } from 'application/contexts/useSupporterChatRoom';
import { ScrollToTop } from 'ui/components/layouts/ScrollToTop';
import { LocationTracker } from 'application/hooks/useLocationTracker';
import { Outlet } from 'react-router-dom';

const SupporterContextConfig: FC = () => {
    return (
        <LoadingProvider>
            <LocationTracker />
            <ScrollToTop />
            <SupporterContexts />
        </LoadingProvider>
    );
};

const SupporterContexts: FC = () => {
    const supportUserCtx = useSupportUser();
    const supporterChatCtx = useSupporterChat();
    return (
        <diContainerContext.Provider value={container}>
            <supportUserContext.Provider value={supportUserCtx}>
                <supporterChatContext.Provider value={supporterChatCtx}>
                    <Outlet />
                </supporterChatContext.Provider>
            </supportUserContext.Provider>
        </diContainerContext.Provider>
    );
};

export default SupporterContextConfig;
